import React, { useState, useRef, useEffect, useContext, useMemo } from 'react';
import {
    Box,
    Typography,
    TextField,
    Button,
    Card,
    CardContent,
    Tabs,
    Tab,
    Select,
    MenuItem,
    FormControl,
    IconButton,
    Chip,
    styled,
    InputLabel,
    List,
    ListItem,
    Grid,
    Radio,
    RadioGroup,
    FormControlLabel,
    ClickAwayListener,
    Paper, ListItemText
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { ReactComponent as DeleteIcon } from "../../../images/DeleteIcon.svg";
import { useLocation, useNavigate } from "react-router-dom";
import InputAdornment from "@mui/material/InputAdornment";
import CloseIcon from "@mui/icons-material/Close";
import yaml from "js-yaml";
import { RemoveCircleOutline } from "@mui/icons-material";
import { ReactComponent as APIAddIcon } from "../../../images/APIAddIcon.svg";
import MessagePopup from "../../popup-components/MessagePopup";
import { LoadingModalContext } from "../../main-pages/ServicePage";
import APIDocPopup from "./APIDocPopup";
import { ReactComponent as ResetIcon } from "../../../images/ResetIconNewAPI.svg"
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import {
    ArrowBack,
    Add,
    Close,
    Search,
    DataObject,
    Description,
    RestartAlt,
    ArrowForward,
    Soap,
    GraphQL
} from '@mui/icons-material';
import { ReactComponent as RestIcon } from "../../../images/RestAPIIcon.svg";
import { ReactComponent as SOAPIcon } from "../../../images/SOAPAPIICon.svg";
import { ReactComponent as GraphQLIcon } from "../../../images/GraphQLIcon.svg";
import ArrowBackIosTwoToneIcon from '@mui/icons-material/ArrowBackIosTwoTone';
import ArrowForwardIosTwoToneIcon from '@mui/icons-material/ArrowForwardIosTwoTone';
import { ReactComponent as LoadSampleIcon } from "../../../images/LoadSampleAPIIcon.svg"
import { handleProgressBar } from "../../custom-components/ProgressBar/ProgressBarWithAPI";
import {
    generateTestCasesForAPI,
    swaggerToPostman,
    apiDetailsToYAML,
    APITraceabilityMatrix
} from "../../../services/webServices";
import { ReactComponent as GenerateButtonIcon } from "../../../images/GenerateApiDocIcon.svg";
import { Snackbar, Alert } from '@mui/material';


const StyledCard = styled(Card)(({ theme }) => ({
    //  border: '2px solid #e3f2fd',
    borderRadius: '12px',
    boxShadow: 'none',
    width: "100%",
    // height: { xs: "60vh", sm: "65vh", md: "73vh" }, // 

    overflowY: "scroll", // scrolling works
    scrollbarWidth: "none", // Firefox
    "&::-webkit-scrollbar": {
        display: "none", // Chrome, Safari, Edge
    },  // adds scroll if content is taller
    // mx: "auto",
    mb: 1

}));

const StyledTabs = styled(Tabs)(({ theme }) => ({
    '& .MuiTabs-indicator': {
        backgroundColor: '#2196f3',
    },
    '& .MuiTab-root': {
        textTransform: 'none',
        minWidth: 'auto',
        padding: '12px 16px',
        fontSize: '16px',
        fontWeight: 500,
        color: 'black'
    },
    '& .MuiTab-root.Mui-selected': {
        color: '#2196f3',
    }
}));

const EndpointTab = styled(Box)(({ theme, active, isLast, isFirst }) => ({
    display: "flex",
    alignItems: "center",
    padding: "8px 12px",
    borderLeft: isFirst ? "none" : "0.5px solid #999",
    cursor: "pointer",
    whiteSpace: "nowrap",
    transition: "all 0.2s ease",
    backgroundColor: active ? "#e3f2fd" : "transparent",
    "&:hover": {
        backgroundColor: "#f5f5f5",
    },
    borderRight: isLast ? "0.5px solid #999" : "none"

}));

const APITypeCard = styled(Box)(({ theme, disabled }) => ({
    display: 'flex',
    flex: 1,
    alignItems: 'left',
    flexDirection: 'column',
    justifyContent: "left",
    padding: '20px 16px',
    border: "1px solid #e0e0e0",
    borderRadius: "8px",
    backgroundColor: "#fff",
    cursor: disabled ? "" : "pointer",
    opacity: disabled ? 0.5 : 1,
    transition: "all 0.2s ease",
    "&:hover": {
        backgroundColor: "#fff", // no color change on hover
    },

}));

const ManualConfigForMultiSource = (props) => {

    const location = useLocation();
    const navigate = useNavigate();

    const [apiUrl, setApiUrl] = useState(props.apiUrl || '');
    const [httpMethod, setHttpMethod] = useState('GET');
    const [path, setPath] = useState('');
    const [description, setDescription] = useState('');
    const [activeTab, setActiveTab] = useState(0);
    const [selectedApiType, setSelectedApiType] = useState('REST');
    const [urlError, setUrlError] = useState("");
    const [protocol, setProtocol] = useState(props.protocol || "http://");
    const [headerKey, setHeaderKey] = useState("");
    const [headerValue, setHeaderValue] = useState("");
    const [keyValuePairs, setKeyValuePairs] = useState([]);
    const [authMethod, setAuthMethod] = useState("");
    const [bearerToken, setBearerToken] = useState("");
    const [authUserName, setAuthUserName] = useState("");
    const [authPassword, setAuthPassword] = useState("");
    const [authKeyName, setAuthKeyName] = useState("");
    const [authKeyValue, setAuthKeyValue] = useState("");
    const [authAddto, setAuthAddto] = useState("");
    const [auth2Flow, setAuth2Flow] = useState("");
    const [authClientID, setAuthClientID] = useState("");
    const [authClientSecret, setAuthClientSecret] = useState("");
    const [authorizationURL, setAuthorizationURL] = useState("");
    const [tokenURL, setTokenURL] = useState("");
    const [scope, setScope] = useState("");
    const [apiType, setApiType] = useState("REST");
    const [apiDocument, setApiDocument] = useState("");
    const { setLoadingState } = useContext(LoadingModalContext);
    const [successPopup, setSuccessPopup] = useState(false);
    const [popupOpen, setPopupOpen] = useState(false);
    const [popupMessage, setPopupMessage] = useState("")
    const [activeEndpointId, setActiveEndpointId] = useState('1');
    const [showSearch, setShowSearch] = useState(false);
    const [snackBarOpen, setSnackBarOpen] = useState(false);
    const [snackBarErrorOpen, setSnackBarErrorOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [showSuggestions, setShowSuggestions] = useState(false);
    const textFieldRef = useRef(null);
    const [displayPageContent, setDisplayPageContent] = useState(location.state?.displayPageContent || []);
    const [overAllEndpointExtractedData, setOverAllEndpointExtractedData] = useState(location.state?.overAllEndpointExtractedData || []);
    const [isIconNecessary, setIsIconNecessary] = useState(location.state?.isIconNecessary || false);
    const [uploadedFile, setUploadedFile] = useState(location.state?.uploadedFile || null);
    const [headerInputs, setHeaderInputs] = useState({});




    const [endpoints, setEndpoints] = useState(() => {
        // If endpoints data is passed as props, use it; otherwise use default
        if (props.endpoints && props.endpoints.length > 0) {
            return props.endpoints;
        }

        return [
            {
                id: "1",
                label: "Endpoint 1",
                method: "GET",
                path: "",
                description: "",
                responseType: "",
                queryParams: [],
                formDataParams: [],
                jsonBody: "",
                xmlBody: "",
                bodyType: "none", // ADD THIS
                headers: [],
                // Authorization fields
                authMethod: "none",
                bearerToken: "",
                authUserName: "",
                authPassword: "",
                authKeyName: "",
                authKeyValue: "",
                authAddto: "none",
                auth2Flow: "",
                authClientID: "",
                authClientSecret: "",
                authorizationURL: "",
                tokenURL: "",
                scope: "",
                active: true
            },
        ];
    });
    const scrollContainerRef = useRef(null);
    const [prevLength, setPrevLength] = useState(endpoints.length);
    const [endpointFormData, setEndpointFormData] = useState({});


    useEffect(() => {
        if (endpoints.length > prevLength) {

            if (scrollContainerRef.current) {
                scrollContainerRef.current.scrollTo({
                    left: scrollContainerRef.current.scrollWidth,
                    behavior: "smooth", // smooth scroll instead of jump
                });
            }
        }
        setPrevLength(endpoints.length); // update stored length
    }, [endpoints, prevLength]);

    // Arrow scroll functions


    useEffect(() => {
        if (endpoints.length === 0) {
            const firstEndpoint = createNewEndpoint(1);
            setEndpoints([firstEndpoint]);
            setActiveEndpointId(firstEndpoint.id);
        }
    }, []);

    useEffect(() => {
        if (location.state?.displayPageContent && location.state?.displayPageContent.length > 0) {
            setDisplayPageContent(location.state.displayPageContent);
            setOverAllEndpointExtractedData(location.state.overAllEndpointExtractedData)
            setIsIconNecessary(location.state.isIconNecessary || false);
            setUploadedFile(location.state.uploadedFile || null);
        }
    }, [location.state]);

    const scrollLeft = () => {
        if (scrollContainerRef.current) {
            const container = scrollContainerRef.current;
            const scrollAmount = container.offsetWidth / 6;
            container.scrollBy({
                left: -scrollAmount,
                behavior: 'smooth'
            });
        }
    };

    const scrollRight = () => {
        if (scrollContainerRef.current) {
            const container = scrollContainerRef.current;
            const scrollAmount = container.offsetWidth / 6;
            container.scrollBy({
                left: scrollAmount,
                behavior: 'smooth'
            });
        }
    };


    const filteredEndpoints = useMemo(() => {
        if (!searchTerm.trim()) {
            return endpoints; // Return all endpoints if search is empty
        }
        return endpoints.filter(endpoint =>
            endpoint.label.toLowerCase().includes(searchTerm.toLowerCase())
        );
    }, [endpoints, searchTerm]);

    const handleSearchIconClick = () => {
        setShowSearch(true);
        setTimeout(() => {
            if (textFieldRef.current) {
                textFieldRef.current.focus();
            }
        }, 100);
    };

    const handleClickAway = () => {
        if (!searchTerm.trim()) {
            setShowSearch(false);
        }
        setShowSuggestions(false);
    };

    const handleClearSearch = () => {
        setSearchTerm('');
        setShowSuggestions(false);
        if (textFieldRef.current) {
            textFieldRef.current.focus();
        }
    };

    const handleInputChange = (e) => {
        const value = e.target.value;
        setSearchTerm(value);
        setShowSuggestions(value.trim().length > 0);
    };
    const handleSuggestionSelect = (endpoint) => {
        setSearchTerm(endpoint.label);
        setShowSuggestions(false);

    };

    const handleInputFocus = () => {
        if (searchTerm.trim().length > 0) {
            setShowSuggestions(true);
        }
    };

    const suggestions = searchTerm.trim() ? filteredEndpoints : [];



    const handleRemove = (index) => {
        setEndpoints((prev) => prev.filter((_, i) => i !== index));
    };
    const handleCloseSuccessPopup = () => {
        setSuccessPopup(false);
    };


    const createNewEndpoint = (number) => {
        const id = `ep_${Date.now()}_${Math.random().toString(36).slice(2, 5)}`;
        return {
            id,
            label: `Endpoint ${number}`,
            method: "GET",
            path: "",
            description: "",
            queryParams: [],
            formDataParams: [],
            jsonBody: "",
            xmlBody: "",
            responseType: "",
            headers: [],
            bodyType: "none",
            // Authorization fields
            authMethod: "none",
            bearerToken: "",
            authUserName: "",
            authPassword: "",
            authKeyName: "",
            authKeyValue: "",
            authAddto: "none",
            auth2Flow: "",
            authClientID: "",
            authClientSecret: "",
            authorizationURL: "",
            tokenURL: "",
            scope: "",


        };
    };

    const updateActiveEndpoint = (updates) => {
        setEndpoints(prev =>
            prev.map(ep =>
                ep.id === activeEndpointId
                    ? { ...ep, ...updates }
                    : ep
            )
        );
    };



    //   const addEndpoint = () => {
    //   setEndpoints(prev => {
    //     const id = `ep_${Date.now()}_${Math.random().toString(36).slice(2,5)}`;
    //     const newEndpoint = {
    //       id,
    //       label: `Endpoint ${prev.length + 1}`,
    //       active: true,                // make the new one active; change to false if not desired
    //       method: "GET",
    //       path: "",
    //       description: "",
    //       queryParams: [],
    //       formDataParams: [],
    //       jsonBody: "",
    //       xmlBody: "",
    //       responseType: "",
    //       headers: [],
    //       bodyType: "none",
    //       // Authorization fields
    //       authMethod: "none",
    //       bearerToken: "",
    //       authUserName: "",
    //       authPassword: "",
    //       authKeyName: "",
    //       authKeyValue: "",
    //       authAddto: "none",
    //       auth2Flow: "",
    //       authClientID: "",
    //       authClientSecret: "",
    //       authorizationURL: "",
    //       tokenURL: "",
    //       scope: "",
    //     };

    //     // Deactivate existing endpoints (so single active at a time)
    //     const deactivated = prev.map(ep => ({ ...ep, active: false }));
    //     return [...deactivated, newEndpoint];
    //   });

    //   setHeaderKey("");
    //   setHeaderValue("");
    // };

    const addEndpoint = () => {
        const newEndpoint = createNewEndpoint(endpoints.length + 1);
        setEndpoints(prev => [...prev, newEndpoint]);
        setActiveEndpointId(newEndpoint.id); // Auto-select new endpoint
        setActiveTab(0);
    };

    const getActiveEndpoint = () => {
        return endpoints.find(ep => ep.id === activeEndpointId) || endpoints[0];
    };
    const handleAddQueryParam = (index) => {
        console.log("=== handleAddQueryParam called ===");
        console.log("Index received:", index);
        console.log("Current endpoints:", endpoints);
        console.log("ActiveEndpointId:", activeEndpointId);

        const formData = getEndpointFormData(index);
        console.log("Form data retrieved:", formData);

        if (formData.queryKey.trim() !== "" && formData.queryValue.trim() !== "") {
            console.log("Adding query param - Key:", formData.queryKey, "Value:", formData.queryValue);

            // Add the query parameter to the endpoint
            setEndpoints((prev) => {
                const updated = prev.map((ep, i) => {
                    if (i === index) {
                        console.log("Updating endpoint at index:", i, "Current queryParams:", ep.queryParams);
                        return {
                            ...ep,
                            queryParams: [
                                ...(ep.queryParams || []),
                                { key: formData.queryKey, value: formData.queryValue },
                            ],
                        };
                    }
                    return ep;
                });
                console.log("Updated endpoints:", updated);
                return updated;
            });

            // Clear the form fields
            setEndpointFormData((prev) => ({
                ...prev,
                [index]: {
                    ...getEndpointFormData(index),
                    queryKey: "",
                    queryValue: "",
                },
            }));
        } else {
            console.log("Form data is empty - Key:", formData.queryKey, "Value:", formData.queryValue);
        }
        console.log("=== handleAddQueryParam end ===");
    };





    const tabLabels = ['Path', 'Query Parameters', 'Header', 'Body', 'Authorization'];

    const apiTypes = [
        {
            id: 'REST',
            label: 'REST',
            description: 'Resource-based HTTP API',
            icon: <RestIcon />
        },
        {
            id: 'SOAP',
            label: 'SOAP',
            description: 'XML-based protocol',
            icon: <SOAPIcon sx={{ color: '#666' }} />
        },
        {
            id: 'GraphQL',
            label: 'GraphQL',
            description: 'Query language for APIs',
            icon: <GraphQLIcon sx={{ color: '#666' }} />
        }
    ];



    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
    };

    const validateUrl = (url) => {
        if (!url) return "URL is required";

        const cleanUrl = url.replace(/^https?:\/\//, '');

        // Check if URL has a domain extension
        const domainExtensionPattern = /\.[a-zA-Z]{2,}$/;

        if (!domainExtensionPattern.test(cleanUrl)) {
            return "URL must contain a valid domain extension (e.g., .com, .org, .net)";
        }



        //  Check basic URL structure
        const basicUrlPattern = /^[a-zA-Z0-9][a-zA-Z0-9\-\.]*[a-zA-Z0-9]\.[a-zA-Z]{2,}(\/.*)?$/;
        if (!basicUrlPattern.test(cleanUrl)) {
            return "Please enter a valid URL format";
        }

        return "";
    };

    const handleEndpointChange = (id) => {
        // setEndpoints((prev) =>
        //     prev.map((ep) => ({ ...ep, active: ep.id === id }))
        // );
        setActiveEndpointId(id);
        setActiveTab(0);
    };

    // Fixed remove endpoint with proper active state handling
    const handleRemoveEndpoint = (id) => {
        setEndpoints(prev => {
            const filtered = prev.filter(ep => ep.id !== id);

            // If we removed the active endpoint, set a new active one
            if (id === activeEndpointId && filtered.length > 0) {
                setActiveEndpointId(filtered[filtered.length - 1].id);
            }

            // Relabel endpoints
            return filtered.map((ep, idx) => ({
                ...ep,
                label: `Endpoint ${idx + 1}`
            }));
        });
    };
    // Remove an endpoint
    // const handleRemoveEndpoint = (id) => {
    //     console.log("Hello")
    //     setEndpoints((prev) => prev.filter((ep) => ep.id !== id));
    // };

    // Add new endpoint
    // const handleAddEndpoint = () => {
    //     const newId = `endpoint${endpoints.length + 1}`;
    //     setEndpoints((prev) => [
    //         ...prev,
    //         { id: newId, label: `End Point 0${endpoints.length + 1}`, active: false },
    //     ]);
    // };

    const getEndpointFormData = (index) => {
        return (
            endpointFormData[index] || {
                queryKey: "",
                queryValue: "",
                formDataKey: "",
                formDataValue: "",
            }
        );
    };

    const updateEndpointFormData = (index, field, value) => {
        setEndpointFormData((prev) => ({
            ...prev,
            [index]: {
                ...getEndpointFormData(index),
                [field]: value,
            },
        }));
    };

    const handleDeleteQueryParam = (paramIndex, endpointIndex) => {
        setEndpoints((prev) =>
            prev.map((ep, i) =>
                i === endpointIndex
                    ? {
                        ...ep,
                        queryParams: ep.queryParams.filter(
                            (_, idx) => idx !== paramIndex
                        ),
                    }
                    : ep
            )
        );
    };
    const handleAddFormData = (endpointId) => {
        const formData = getEndpointFormData(endpointId);
        if (formData.formDataKey.trim() !== "" && formData.formDataValue.trim() !== "") {
            setEndpoints((prev) =>
                prev.map((ep) =>
                    ep.id === endpointId  // Use ID comparison instead of index
                        ? {
                            ...ep,
                            formDataParams: [
                                ...(ep.formDataParams || []),
                                { key: formData.formDataKey, value: formData.formDataValue },
                            ],
                        }
                        : ep
                )
            );

            setEndpointFormData((prev) => ({
                ...prev,
                [endpointId]: {  // Use ID as key
                    ...getEndpointFormData(endpointId),
                    formDataKey: "",
                    formDataValue: "",
                },
            }));
        }
    };

    const handleDeleteFormData = (paramIndex, endpointIndex) => {
        setEndpoints((prev) =>
            prev.map((ep, i) =>
                i === endpointIndex
                    ? {
                        ...ep,
                        formDataParams: ep.formDataParams.filter(
                            (_, idx) => idx !== paramIndex
                        ),
                    }
                    : ep
            )
        );
    };

    // const handleAddHeader = (index) => {
    //     if (headerKey.trim() && headerValue.trim()) {
    //         setEndpoints((prev) =>
    //             prev.map((ep, i) =>
    //                 i === index
    //                     ? {
    //                         ...ep,
    //                         headers: [
    //                             ...(ep.headers || []),
    //                             { key: headerKey, value: headerValue },
    //                         ],
    //                     }
    //                     : ep
    //             )
    //         );

    //         setKeyValuePairs([
    //             ...keyValuePairs,
    //             { key: headerKey, value: headerValue },
    //         ]);
    //         setHeaderKey("");
    //         setHeaderValue("");

    //     }
    // };

    const handleAddHeader = (index) => {
        const endpointId = endpoints[index].id;
        const { headerKey = "", headerValue = "" } = headerInputs[endpointId] || {};

        if (headerKey.trim() && headerValue.trim()) {
            setEndpoints((prev) =>
                prev.map((ep, i) =>
                    i === index
                        ? {
                            ...ep,
                            headers: [...(ep.headers || []), { key: headerKey, value: headerValue }],
                        }
                        : ep
                )
            );

            setKeyValuePairs((prev) => [
                ...prev,
                { key: headerKey, value: headerValue },
            ]);

            // clear only current endpoint’s inputs
            setHeaderInputs((prev) => ({
                ...prev,
                [endpointId]: { headerKey: "", headerValue: "" },
            }));
        }
    };

    const activeEndpoint = getActiveEndpoint();

    const handleDeleteHeader = (headerIndex, endpointIndex) => {
        const headerToDelete = endpoints[endpointIndex].headers[headerIndex];
        if (headerToDelete.isAuthHeader) {
            return;
        }
        setEndpoints((prev) =>
            prev.map((ep, i) =>
                i === endpointIndex
                    ? {
                        ...ep,
                        headers: ep.headers.filter((_, idx) => idx !== headerIndex),
                    }
                    : ep
            )
        );

        setKeyValuePairs((prev) =>
            prev.filter(
                (header) =>
                    !(
                        header.key === headerToDelete.key &&
                        header.value === headerToDelete.value
                    )
            )
        );
    };

    const handleDownloadAPIDocument = (apiDocument) => {
        if (!apiDocument) return;

        try {
            const yamlString = yaml.dump(apiDocument.data);
            const blob = new Blob([yamlString], { type: "text/yaml" });
            const url = URL.createObjectURL(blob);

            const a = document.createElement("a");
            a.href = url;
            a.download = "openapi-document.yaml";
            document.body.appendChild(a);
            a.click();

            document.body.removeChild(a);
            URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Error converting OpenAPI document to YAML:", error);
            setPopupMessage("Error downloading API document. Please try again.");

        }
    };


    function flattenPostmanItems(items) {
        const flat = [];

        function recurse(subItems) {
            subItems.forEach(item => {
                if (item.request) {
                    flat.push(item); // it's a request
                } else if (item.item && item.item.length > 0) {
                    recurse(item.item); // it's a folder
                }
            });
        }

        recurse(items);
        return flat;
    }


    const generateAPIDocumentation = async () => {
        //setLoading(true);
        try {
            const authorizationCommon = {};
            const manualDetailsData = {
                apiUrl: apiUrl,
                apiType: apiType,
                // method: method,
                // keyValuePairs: keyValuePairs,
                endpoints: endpoints,


                protocol: protocol,
            };
            const response = await apiDetailsToYAML(manualDetailsData);
            // const response = await manualDetails(manualDetailsData);


            setApiDocument(response.data);

            navigate("/dashboard/api-testing/multi-source-combination", {
                state: {
                    ...location.state,
                    apiDocData: response.data || null,
                    apiUrl: apiUrl,
                    apiType: apiType,
                    endpoints: endpoints,
                    protocol: protocol,
                    displayPageContent: displayPageContent,
                    overAllEndpointExtractedData: overAllEndpointExtractedData,
                    isIconNecessary: isIconNecessary,
                    uploadedFile: uploadedFile,


                }
            });

        } catch (error) {
            console.error("Error generating test cases:", error);
            setPopupMessage("Something went wrong while generating the API documentation.");
            setPopupOpen(true);

        } finally {
            //setLoading(false);
        }
    };

    const handleSnackBarClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setSnackBarOpen(false);
        setSnackBarErrorOpen(false);
    };


    const generateTestCases = async () => {
        let tcCounter = 1; // Ensure tcCounter is initialized

        let progressHandler;
        progressHandler = handleProgressBar({ setLoadingState, totalDurationMs: 195000 });
        try {

            const finalArray = [];
            let traceabilityMatrix = null;
            progressHandler.start(`Generating Test Cases for API Endpoints`);

            const responseData = await swaggerToPostman(apiDocument.data);

            if (responseData.data.item) {
                const flattenedItems = flattenPostmanItems(responseData.data.item);


                const promises = flattenedItems.map(async (item, index) => {


                    try {
                        const testcasesresponse = await generateTestCasesForAPI(item);

                        if (testcasesresponse.data && testcasesresponse.data?.testcases) {

                            return testcasesresponse.data.testcases;
                        }
                    } catch (error) {
                        console.log(
                            error?.response?.data?.error || error.message,
                            "Error processing swagger item:", index + 1
                        );
                        // setPopupMessage(`Error processing item ${i + 1}: ${error?.response?.data?.error || error.message}`);
                        // setPopupOpen(true);
                    }
                    return []; // Return an empty array if there's an error
                }

                );



                const results = await Promise.allSettled(promises);

                // Flatten results and assign Test Case IDs safely
                for (const result of results) {
                    if (result.status === "fulfilled" && Array.isArray(result.value)) {
                        const updated = result.value.map((testcase) => {
                            const isFunctional = testcase.Category?.toLowerCase() === "functional testing";
                            const subCategory = testcase["Sub-Category"]?.toLowerCase() || "";

                            let prefix = isFunctional ? "TCD_FT" : "TCD_NFT";
                            let shortCode = "";

                            if (subCategory.includes("positive")) shortCode = "POS";
                            else if (subCategory.includes("negative")) shortCode = "NEG";
                            else if (subCategory.includes("boundary")) shortCode = "BOUND";
                            else if (subCategory.includes("error")) shortCode = "ERR";
                            else if (subCategory.includes("security")) shortCode = "SEC";
                            else if (subCategory.includes("performance")) shortCode = "PERF";

                            const padded = String(tcCounter).padStart(2, "0");
                            const id = `${prefix}_${padded}_${shortCode}`;
                            tcCounter++;

                            return {
                                ...testcase,
                                "Test Case ID": id,
                            };
                        });

                        finalArray.push(...updated);
                    }
                }



                const filteredTestCases = finalArray.map((testcase) => ({
                    "Test Case ID": testcase["Test Case ID"],
                    "API Endpoint": testcase["API Endpoint"],
                    "Method": testcase["Method"],
                    "Test Description": testcase["Test Description"],
                    "Category": testcase["Category"],
                }));

                try {
                    progressHandler.updateMessage("Generating Traceability Matrix");
                    const response = await APITraceabilityMatrix(filteredTestCases);
                    if (response.data !== null) {
                        traceabilityMatrix = response.data;
                    }
                } catch (error) {
                    console.log(
                        error?.response?.data?.error || error.message,
                        "Error generating traceability matrix"
                    );
                    setPopupMessage("Error generating traceability matrix");
                    setPopupOpen(true);
                }

                await progressHandler.finishAndClose();

                navigate("/dashboard/api-testing/manual", {
                    state: {
                        ...location.state,
                        generateTestCasesData: finalArray,
                        apiDocData: apiDocument || null,
                        button: "configureAPIDefinition",
                        traceabilityMatrix: traceabilityMatrix,
                    },
                });
            }
        } catch (error) {
            console.error("Error generating test cases:", error);
            setLoadingState({ open: false, message: "", progress: null });
            setPopupMessage("Something went wrong while generating the test cases.");
            setPopupOpen(true);
        } finally {
            if (progressHandler) {
                progressHandler.stop();
            }
            setLoadingState({ open: false, message: "", progress: null });
        }
    };

    const handleAPIDetailsLoadDemoExample = (e) => {
        e.stopPropagation();

        // Set common API details
        setApiUrl("bookstore.toolsqa.com");
        setApiType("rest");


        // Generate sample endpoints with proper structure
        const sampleEndpoints = [
            {
                id: `ep_${Date.now()}_001`,
                label: "Endpoint 1",
                method: "POST",
                path: "/Account/v1/Authorized",
                description: "Check if user credentials are valid",
                responseType: "application/json",
                queryParams: [],
                formDataParams: [],
                headers: [
                    { key: "Content-Type", value: "application/json", isAuthHeader: false }
                ],
                bodyType: "json",
                jsonBody: JSON.stringify({
                    "userName": "string",
                    "password": "string"
                }, null, 2),
                xmlBody: "",
                // Auth fields from your createNewEndpoint structure
                authMethod: "Basic Auth",
                bearerToken: "",
                authUserName: "authorization",
                authPassword: "BASE64(username:password)",
                authKeyName: "",
                authKeyValue: "",
                authAddto: "header",
                auth2Flow: "",
                authClientID: "",
                authClientSecret: "",
                authorizationURL: "",
                tokenURL: "",
                scope: ""
            },
            {
                id: `ep_${Date.now()}_002`,
                label: "Endpoint 2",
                method: "POST",
                path: "/Account/v1/User",
                description: "Create a new user",
                responseType: "application/json",
                queryParams: [{ key: "username", value: "string" }],
                formDataParams: [],
                headers: [
                    { key: "Content-Type", value: "application/json", isAuthHeader: false }
                ],
                bodyType: "json",
                jsonBody: JSON.stringify({
                    "userName": "string",
                    "password": "string",
                    "userId": "GUID"
                }, null, 2),
                xmlBody: "",
                authMethod: "none",
                bearerToken: "",
                authUserName: "",
                authPassword: "",
                authKeyName: "",
                authKeyValue: "",
                authAddto: "none",
                auth2Flow: "",
                authClientID: "",
                authClientSecret: "",
                authorizationURL: "",
                tokenURL: "",
                scope: ""
            },
            {
                id: `ep_${Date.now()}_003`,
                label: "Endpoint 3",
                method: "GET",
                path: "/Account/v1/User/{UserId}",
                description: "Get user details including books",
                responseType: "application/json",
                queryParams: [],
                formDataParams: [],
                headers: [
                    { key: "authorization", value: "Bearer YOUR_TOKEN", isAuthHeader: true }
                ],
                bodyType: "none",
                jsonBody: "",
                xmlBody: "",
                authMethod: "Bearer Token",
                bearerToken: "YOUR_TOKEN",
                authUserName: "",
                authPassword: "",
                authKeyName: "",
                authKeyValue: "",
                authAddto: "header",
                auth2Flow: "",
                authClientID: "",
                authClientSecret: "",
                authorizationURL: "",
                tokenURL: "",
                scope: ""
            },
            {
                id: `ep_${Date.now()}_004`,
                label: "Endpoint 4",
                method: "GET",
                path: "/BookStore/v1/Books",
                description: "Retrieve list of all books",
                responseType: "application/json",
                queryParams: [],
                formDataParams: [],
                headers: [
                    { key: "accept", value: "application/json", isAuthHeader: false }
                ],
                bodyType: "none",
                jsonBody: "",
                xmlBody: "",
                authMethod: "none",
                bearerToken: "",
                authUserName: "",
                authPassword: "",
                authKeyName: "",
                authKeyValue: "",
                authAddto: "none",
                auth2Flow: "",
                authClientID: "",
                authClientSecret: "",
                authorizationURL: "",
                tokenURL: "",
                scope: ""
            },
            {
                id: `ep_${Date.now()}_005`,
                label: "Endpoint 5",
                method: "DELETE",
                path: "/BookStore/v1/Books",
                description: "Remove book(s) from a user's collection",
                responseType: "application/json",
                queryParams: [],
                formDataParams: [],
                headers: [
                    { key: "authorization", value: "Bearer YOUR_TOKEN", isAuthHeader: true },
                    { key: "Content-Type", value: "application/json", isAuthHeader: false }
                ],
                bodyType: "json",
                jsonBody: JSON.stringify({
                    "userId": "GUID",
                    "isbn": "string"
                }, null, 2),
                xmlBody: "",
                authMethod: "Bearer Token",
                bearerToken: "YOUR_TOKEN",
                authUserName: "",
                authPassword: "",
                authKeyName: "",
                authKeyValue: "",
                authAddto: "header",
                auth2Flow: "",
                authClientID: "",
                authClientSecret: "",
                authorizationURL: "",
                tokenURL: "",
                scope: ""
            },
            {
                id: `ep_${Date.now()}_006`,
                label: "Endpoint 6",
                method: "GET",
                path: "/Account/v1/User",
                description: "Get list of all users",
                responseType: "application/json",
                queryParams: [],
                formDataParams: [],
                headers: [
                    { key: "authorization", value: "Basic BASE64(admin:password)", isAuthHeader: true }
                ],
                bodyType: "none",
                jsonBody: "",
                xmlBody: "",
                authMethod: "Basic Auth",
                bearerToken: "",
                authUserName: "admin",
                authPassword: "password",
                authKeyName: "",
                authKeyValue: "",
                authAddto: "header",
                auth2Flow: "",
                authClientID: "",
                authClientSecret: "",
                authorizationURL: "",
                tokenURL: "",
                scope: ""
            },
            {
                id: `ep_${Date.now()}_007`,
                label: "Endpoint 7",
                method: "DELETE",
                path: "/Account/v1/User/{UserId}",
                description: "Delete a user by userId",
                responseType: "application/json",
                queryParams: [],
                formDataParams: [],
                headers: [
                    { key: "authorization", value: "Bearer BASE64(admin:password)", isAuthHeader: true }
                ],
                bodyType: "none",
                jsonBody: "",
                xmlBody: "",
                authMethod: "API Key",
                bearerToken: "",
                authUserName: "",
                authPassword: "",
                authKeyName: "authorization",
                authKeyValue: "Bearer BASE64(admin:password)",
                authAddto: "header",
                auth2Flow: "",
                authClientID: "",
                authClientSecret: "",
                authorizationURL: "",
                tokenURL: "",
                scope: ""
            }
        ];

        // Set the endpoints
        setEndpoints(sampleEndpoints);

        // Set the first endpoint as active
        if (sampleEndpoints.length > 0) {
            setActiveEndpointId(sampleEndpoints[0].id);
        }

        // Reset form data states
        setHeaderKey("");
        setHeaderValue("");

        // Clear endpoint form data
        setEndpointFormData({});

        // Optional: Reset to first tab
        setActiveTab(0);

        // Optional: Show success message
        console.log("Sample data loaded successfully!");
    };


    const resetActiveEndpoint = () => {
        const activeIndex = endpoints.findIndex(ep => ep.id === activeEndpointId);
        if (activeIndex === -1) return; // Exit if active endpoint not found

        const currentEndpoint = endpoints[activeIndex];
        const resetEndpoint = {
            ...createNewEndpoint(activeIndex + 1), // Keep the numbering consistent
            id: currentEndpoint.id, // Preserve the original ID
            label: currentEndpoint.label, // Preserve the original label
        };

        setEndpoints(prev =>
            prev.map(ep =>
                ep.id === activeEndpointId ? resetEndpoint : ep
            )
        );

        // Also reset the form data for this endpoint
        setEndpointFormData(prev => ({
            ...prev,
            [activeEndpointId]: {
                formDataKey: "",
                formDataValue: "",
                headerKey: "",
                headerValue: "",
            }
        }));
    };




    return (
        <Box sx={{
            p: 2,
            bgcolor: "#F6F3F2",
            height: "100%",      // fill whatever space parent gave
            maxHeight: "100%",   // don’t exceed it
            minHeight: 0,
            display: "flex",
            flexDirection: "column",
        }}>
            <StyledCard >
                <CardContent>
                    {/* Header */}
                    <Box >
                        <Typography
                            variant="Subtitle1" fontWeight="bold" fontSize={17}
                        >
                            Manual Configuration
                        </Typography>

                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2, mt: 1.5 }}>
                            Configure your API manually for complete control over test generation parameters
                        </Typography>
                    </Box>

                    {/* API Type Section */}
                    <Box sx={{ mb: 2 }}>
                        <Typography
                            variant="subtitle1"
                            sx={{ mb: 2, fontWeight: 550, fontSize: 15 }}
                        >
                            API Type
                        </Typography>
                        <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                            {apiTypes.map((apiType, index) => (
                                <APITypeCard
                                    key={apiType.id}
                                    disabled={index !== 0} // only first enabled
                                >
                                    <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                                        {apiType.icon}
                                        <Box>
                                            <Typography
                                                variant="body1"
                                                sx={{
                                                    fontWeight: 600,
                                                    color: index === 0 ? "black" : "#999",
                                                }}
                                            >
                                                {apiType.label}
                                            </Typography>

                                            <Typography variant="caption" sx={{ color: "#666" }}>
                                                {apiType.description}
                                            </Typography>
                                        </Box>
                                    </Box>


                                </APITypeCard>
                            ))}
                        </Box>
                    </Box>

                    {/* API URL Section */}
                    <Box sx={{ mb: 1.5 }}>
                        <Box sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            marginBottom: '12px'
                        }}>
                            <Typography
                                variant="subtitle1"
                                sx={{ fontWeight: 550, fontSize: 15 }}
                            >
                                API URL
                            </Typography>
                            <Button
                                variant="text"
                                startIcon={<LoadSampleIcon />}
                                sx={{
                                    color: '#0094FB',
                                    textTransform: 'none',
                                    fontWeight: 550
                                }}
                                onClick={handleAPIDetailsLoadDemoExample}
                            >
                                Load Sample Data
                            </Button>
                        </Box>
                        <TextField
                            fullWidth
                            required
                            variant="outlined"
                            placeholder="Enter URL"
                            label="API URL"
                            value={apiUrl}
                            onChange={(e) => setApiUrl(e.target.value)}
                            onBlur={(e) => setUrlError(validateUrl(e.target.value))}
                            error={!!urlError}
                            helperText={urlError}
                            sx={{ mb: 3 }}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <Select
                                            value={protocol}
                                            onChange={(e) => setProtocol(e.target.value)}
                                            //variant="text" // Use outlined for full background
                                            variant="standard" // No visible outline
                                            disableUnderline
                                            sx={{
                                                minWidth: 85,
                                                mr: 1,
                                                bgcolor: "#F4F2EC",
                                                height: "40px",

                                                "& .MuiSelect-select": {
                                                    display: "flex",
                                                    alignItems: "center",
                                                    borderRadius: "8px", // Curved corners
                                                    px: 0.8,
                                                    py: 0.5,
                                                },
                                            }}
                                        >
                                            <MenuItem value="http://">http://</MenuItem>
                                            <MenuItem value="https://">https://</MenuItem>
                                        </Select>
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </Box>

                    {/* Manual API Endpoint Setup */}
                    <Box sx={{ marginBottom: '24px' }}>
                        <Typography
                            variant="Subtitle1" fontWeight="bold" fontSize={17}
                        >
                            Manual API Endpoint Setup
                        </Typography>
                        <Typography
                            variant="body2"
                            color="text.secondary" sx={{ mb: 2, mt: 1 }}
                        >
                            Configure REST API endpoints manually by specifying the HTTP path, query parameters, headers, body, and authorization.
                        </Typography>

                        {/* Endpoint Navigation */}
                        <Box sx={{
                            display: 'flex',
                            alignItems: 'center',
                            marginBottom: '16px',

                        }}>
                            <Box sx={{
                                border: "0.5px solid #999"

                            }}>
                                <IconButton sx={{
                                    color: '#0094FB'
                                }}
                                    onClick={scrollLeft}
                                >
                                    <ArrowBackIosTwoToneIcon />
                                </IconButton>
                            </Box>

                            <Box
                                ref={scrollContainerRef}
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 0,
                                    flex: 1,
                                    overflowX: 'auto',
                                    minHeight: '40px',
                                    "&::-webkit-scrollbar": { display: "none" },
                                    //border: "0.5px  #999"
                                    border: "0.5px solid #999",
                                    borderLeft: "none"
                                }}>
                                {filteredEndpoints.map((endpoint, index) => (
                                    <EndpointTab
                                        key={endpoint.id}
                                        index={index}
                                        isLast={index === endpoints.length - 1}
                                        isFirst={index === 0}
                                        active={endpoint.id === activeEndpointId}
                                        onClick={() => handleEndpointChange(endpoint.id)}
                                    >
                                        <Typography
                                            variant="body2"
                                            sx={{
                                                color: endpoint.id === activeEndpointId ? '#0094FB' : '#1B1F26B8',
                                                fontWeight: endpoint.id === activeEndpointId ? 600 : 400,
                                                mr: 1,
                                                whiteSpace: 'nowrap'
                                            }}
                                        >
                                            {endpoint.label}
                                        </Typography>
                                        <IconButton
                                            size="small"
                                            sx={{ color: endpoint.id === activeEndpointId ? "#0094FB" : "#1B1F26B8", p: "2px" }}
                                            onClick={(e) => {

                                                e.stopPropagation(); // prevent tab switch on close
                                                handleRemoveEndpoint(endpoint.id);
                                            }}
                                        >
                                            <Close fontSize="small" />
                                        </IconButton>
                                    </EndpointTab>
                                ))}
                            </Box>
                            <Box sx={{ border: "0.5px solid #999", borderLeft: "none" }}>

                                <IconButton sx={{ color: '#0094FB' }}
                                    onClick={scrollRight}>
                                    <ArrowForwardIosTwoToneIcon />
                                </IconButton>
                            </Box>
                            <IconButton sx={{ color: '#0094FB' }} onClick={addEndpoint}>
                                <Add />
                            </IconButton>
                            <ClickAwayListener onClickAway={handleClickAway}>
                                <Box sx={{ position: 'relative', display: 'inline-flex', alignItems: 'center' }}>
                                    {!showSearch && (
                                        <IconButton
                                            sx={{ color: '#0094FB' }}
                                            onClick={handleSearchIconClick}
                                        >
                                            <Search />
                                        </IconButton>
                                    )}

                                    {showSearch && (
                                        <Box sx={{ position: 'relative' }}>
                                            <TextField
                                                ref={textFieldRef}
                                                variant="outlined"
                                                size="small"
                                                placeholder="Search..."
                                                sx={{ ml: 1, width: "200px" }}
                                                value={searchTerm}
                                                onChange={handleInputChange}
                                                onFocus={handleInputFocus}
                                                InputProps={{
                                                    endAdornment: searchTerm && (
                                                        <InputAdornment position="end">
                                                            <IconButton
                                                                size="small"
                                                                onClick={handleClearSearch}
                                                                sx={{ color: '#999' }}
                                                            >
                                                                <Close fontSize="small" />
                                                            </IconButton>
                                                        </InputAdornment>
                                                    )
                                                }}
                                            />

                                            {showSuggestions && (
                                                <Paper
                                                    sx={{
                                                        position: 'absolute',
                                                        top: '100%',
                                                        left: 1,
                                                        right: 0,
                                                        zIndex: 1000,
                                                        maxHeight: '200px',
                                                        overflowY: 'auto',
                                                        mt: 0.5,
                                                        boxShadow: 1
                                                    }}
                                                >
                                                    <List dense sx={{ py: 0 }}>
                                                        {suggestions.length > 0 ? (
                                                            suggestions.map((endpoint, index) => (
                                                                <ListItem
                                                                    key={index}
                                                                    button
                                                                    onClick={() => handleSuggestionSelect(endpoint)}
                                                                    sx={{
                                                                        '&:hover': {
                                                                            backgroundColor: '#f5f5f5'
                                                                        },
                                                                        cursor: 'pointer'
                                                                    }}
                                                                >
                                                                    <ListItemText
                                                                        primary={endpoint.label}
                                                                        sx={{
                                                                            '& .MuiListItemText-primary': {
                                                                                fontSize: '0.875rem'
                                                                            }
                                                                        }}
                                                                    />
                                                                </ListItem>
                                                            ))
                                                        ) : (
                                                            <ListItem sx={{ py: 1 }}>
                                                                <ListItemText
                                                                    primary="No endpoints found"
                                                                    sx={{
                                                                        '& .MuiListItemText-primary': {
                                                                            fontSize: '0.875rem',
                                                                            color: '#999',
                                                                            textAlign: 'center'
                                                                        }
                                                                    }}
                                                                />
                                                            </ListItem>
                                                        )}
                                                    </List>
                                                </Paper>
                                            )}
                                        </Box>
                                    )}
                                </Box>
                            </ClickAwayListener>
                        </Box>

                        {/* Configuration Tabs */}
                        <StyledTabs
                            value={activeTab}
                            onChange={handleTabChange}
                            sx={{ mb: 3 }}
                            variant="fullWidth"
                        >
                            {tabLabels.map((label, index) => (
                                <Tab key={index} label={label} />
                            ))}
                        </StyledTabs>



                        {activeEndpoint && (
                            <Box
                                // key={index}
                                sx={{
                                    p: 2,
                                    border: "1px",
                                    borderRadius: 2,
                                    // backgroundColor: "#49A3FF0F",
                                    mt: 2,
                                    position: "relative",
                                }}
                            >

                                {/* <Typography
                                    variant="subtitle1"
                                    fontWeight={"bold"}
                                    sx={{ fontSize: "" }}
                                >{activeEndpoint.label}</Typography> */}

                                {activeTab === 0 && (
                                    <>

                                        <Box sx={{ display: "flex", alignItems: "center", gap: 2, }}>


                                            <FormControl sx={{ width: "40%", mt: 1.8 }}>
                                                <InputLabel>HTTP Method *</InputLabel>
                                                <Select
                                                    required
                                                    value={activeEndpoint.method}
                                                    onChange={(e) => updateActiveEndpoint({ method: e.target.value })
                                                    }
                                                    label="HTTP Method"
                                                >
                                                    <MenuItem value="GET">GET</MenuItem>
                                                    <MenuItem value="POST">POST</MenuItem>
                                                    <MenuItem value="PUT">PUT</MenuItem>
                                                    <MenuItem value="DELETE">DELETE</MenuItem>
                                                </Select>
                                            </FormControl>
                                            <FormControl sx={{ mt: 1.8, width: "100%" }}>
                                                <TextField
                                                    required
                                                    //sx={{ width: "340px", }}
                                                    fullWidth
                                                    label="Enter Path"
                                                    placeholder="Enter Path"
                                                    value={activeEndpoint.path}
                                                    onChange={(e) => updateActiveEndpoint({ path: e.target.value })}
                                                />
                                            </FormControl>
                                        </Box>
                                        <TextField
                                            fullWidth
                                            placeholder="Enter Description"
                                            label="Description"
                                            value={activeEndpoint.description}
                                            onChange={(e) => updateActiveEndpoint({ description: e.target.value })
                                            }
                                            sx={{ my: 2 }}
                                        />
                                    </>

                                )}


                                {activeTab === 1 && (
                                    <>                               {/* Query Parameters */}

                                        <Box sx={{ display: "flex", alignItems: "center", gap: 2, width: "100%" }}>
                                            <FormControl sx={{ width: "100%" }}>
                                                <TextField
                                                    // sx={{ width: "230px" }}
                                                    fullWidth
                                                    label="Key"
                                                    placeholder="Enter Key"
                                                    value={getEndpointFormData(endpoints.findIndex(ep => ep.id === activeEndpointId)).queryKey}

                                                    onChange={(e) =>
                                                        updateEndpointFormData(endpoints.findIndex(ep => ep.id === activeEndpointId), "queryKey", e.target.value)

                                                    } />

                                            </FormControl>
                                            <FormControl sx={{ width: "100%" }}>
                                                <TextField
                                                    //sx={{ width: "210px" }}
                                                    fullWidth
                                                    label="Value"
                                                    placeholder="Enter Value"
                                                    value={getEndpointFormData(endpoints.findIndex(ep => ep.id === activeEndpointId)).queryValue}
                                                    onChange={(e) =>
                                                        updateEndpointFormData(endpoints.findIndex(ep => ep.id === activeEndpointId), "queryValue", e.target.value)
                                                    }
                                                />
                                            </FormControl>
                                            <Button
                                                onClick={() => {
                                                    const index = endpoints.findIndex(ep => ep.id === activeEndpointId);
                                                    handleAddQueryParam(index);


                                                }}


                                                variant='contained'
                                                sx={{
                                                    height: "50px",
                                                    textTransform: "none",
                                                    bgcolor: "#0094FB",
                                                    borderRadius: 2,
                                                    fontSize: "16px",
                                                }}


                                                disabled={
                                                    !getEndpointFormData(endpoints.findIndex(ep => ep.id === activeEndpointId))?.queryKey?.trim() ||
                                                    !getEndpointFormData(endpoints.findIndex(ep => ep.id === activeEndpointId))?.queryValue?.trim()
                                                }


                                            >
                                                Add
                                            </Button>
                                        </Box>

                                        {/* Display Query Parameters */}
                                        {activeEndpoint?.queryParams?.length > 0 && (

                                            <List sx={{ width: "100%", bgcolor: "#49A3FF0F", mt: 2 }}>
                                                {console.log("Rendering query params for activeEndpoint:", activeEndpoint)}
                                                {console.log("Query params to display:", activeEndpoint.queryParams)}
                                                <ListItem
                                                    sx={{
                                                        borderRadius: 2,
                                                        my: 1,
                                                        px: 2,
                                                        py: 0.5,
                                                        display: "flex",
                                                        alignItems: "center",

                                                    }}
                                                >
                                                    <Grid container alignItems="center" spacing={2}>
                                                        <Grid item xs={5}>
                                                            <Typography
                                                                variant="body1"
                                                                sx={{
                                                                    fontWeight: "bold",
                                                                    color: "#333",
                                                                }}
                                                            >
                                                                Key
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={5}>
                                                            <Typography
                                                                variant="body1"
                                                                sx={{
                                                                    fontWeight: "bold",
                                                                    color: "#333",
                                                                }}
                                                            >
                                                                Value
                                                            </Typography>
                                                        </Grid>

                                                    </Grid>
                                                </ListItem>
                                                {activeEndpoint.queryParams.map((param, paramIndex) => (
                                                    <ListItem
                                                        key={paramIndex}
                                                        sx={{

                                                            borderRadius: 2,
                                                            my: 1,
                                                            px: 2,
                                                            py: 0.5,
                                                            display: "flex",
                                                            alignItems: "center",
                                                        }}
                                                    >
                                                        <Grid container alignItems="center" spacing={2}>
                                                            <Grid item xs={5}>
                                                                <Typography
                                                                    variant="body1"
                                                                    sx={{
                                                                        wordBreak: "break-word",
                                                                        whiteSpace: "normal",
                                                                        overflowWrap: "anywhere",
                                                                    }}
                                                                >
                                                                    {paramIndex + 1}. {param.key}
                                                                    {param.isAuthParam}
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item xs={5}>
                                                                <Typography
                                                                    variant="body2"
                                                                    sx={{
                                                                        fontSize: "14px",
                                                                        color: "#838383",
                                                                        wordBreak: "break-word",
                                                                        whiteSpace: "normal",
                                                                        overflowWrap: "anywhere",
                                                                    }}
                                                                >
                                                                    {/* {param.value} */}
                                                                    {param.isAuthParam ? param.value : param.value}
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item xs={2} sx={{ textAlign: "right" }}>
                                                                <IconButton
                                                                    onClick={() =>
                                                                        handleDeleteQueryParam(paramIndex, endpoints.findIndex(ep => ep.id === activeEndpointId))

                                                                    }
                                                                    color="error"
                                                                    disabled={param.isAuthParam}
                                                                >
                                                                    <DeleteIcon />
                                                                </IconButton>
                                                            </Grid>
                                                        </Grid>
                                                    </ListItem>
                                                ))}
                                            </List>
                                        )}
                                    </>
                                )}
                                {activeTab === 3 && (
                                    <>
                                        {/* Body Configuration */}

                                        <FormControl>
                                            <RadioGroup
                                                row
                                                value={activeEndpoint.bodyType || "none"}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    setEndpoints((prev) =>
                                                        prev.map((ep) =>
                                                            ep.id === activeEndpoint.id ? { ...ep, bodyType: value } : ep
                                                        )
                                                    );
                                                }}
                                                sx={{ mb: 2 }}
                                            >
                                                <FormControlLabel
                                                    value="none"
                                                    control={<Radio />}
                                                    label="None"
                                                    sx={{ "& .MuiTypography-root": { fontSize: "0.850rem" } }}
                                                />
                                                <FormControlLabel
                                                    value="formdata"
                                                    control={<Radio />}
                                                    label="Form Data"
                                                    sx={{ "& .MuiTypography-root": { fontSize: "0.850rem" } }}
                                                />
                                                <FormControlLabel
                                                    value="json"
                                                    control={<Radio />}
                                                    label="JSON"
                                                    sx={{ "& .MuiTypography-root": { fontSize: "0.850rem" } }}
                                                />
                                                <FormControlLabel
                                                    value="xml"
                                                    control={<Radio />}
                                                    label="XML"
                                                    sx={{ "& .MuiTypography-root": { fontSize: "0.850rem" } }}
                                                />
                                            </RadioGroup>
                                        </FormControl>

                                        {/* Form Data Body */}
                                        {(activeEndpoint.bodyType || "none") === "formdata" && (
                                            <Box sx={{ mt: 1 }}>
                                                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                                                    <FormControl sx={{ width: "100%" }}>
                                                        <TextField
                                                            // sx={{ width: "230px" }}
                                                            fullWidth
                                                            label="Field Key"
                                                            placeholder="Enter Key"
                                                            value={getEndpointFormData(activeEndpoint.id).formDataKey}
                                                            onChange={(e) =>
                                                                updateEndpointFormData(
                                                                    activeEndpoint.id,
                                                                    "formDataKey",
                                                                    e.target.value
                                                                )
                                                            }
                                                        />
                                                    </FormControl>
                                                    <FormControl sx={{ width: "100%" }}>
                                                        <TextField
                                                            //sx={{ width: "210px" }}
                                                            fullWidth
                                                            label="Field Value"
                                                            placeholder="Enter Value"
                                                            value={getEndpointFormData(activeEndpoint.id).formDataValue}
                                                            onChange={(e) =>
                                                                updateEndpointFormData(
                                                                    activeEndpoint.id,
                                                                    "formDataValue",
                                                                    e.target.value
                                                                )
                                                            }
                                                        />
                                                    </FormControl>
                                                    <Button
                                                        onClick={() => handleAddFormData(activeEndpoint.id)}
                                                        variant='contained'
                                                        sx={{
                                                            height: "50px",
                                                            textTransform: "none",
                                                            bgcolor: "#0094FB",
                                                            borderRadius: 2,
                                                            fontSize: "16px",
                                                        }}

                                                        //  disabled={
                                                        //     (() => {
                                                        //         const index = endpoints.findIndex(ep => ep.id === activeEndpoint.id);
                                                        //         const formData = getEndpointFormData(index);
                                                        //         return formData.formDataKey.trim() === "" || formData.formDataValue.trim() === "";
                                                        //     })()

                                                        // }
                                                        disabled={
                                                            !getEndpointFormData(activeEndpoint.id)?.formDataKey?.trim() ||
                                                            !getEndpointFormData(activeEndpoint.id)?.formDataValue?.trim()
                                                        }


                                                    >
                                                        Add
                                                    </Button>
                                                </Box>

                                                {/* Display Form Data Parameters */}
                                                {activeEndpoint.formDataParams &&
                                                    activeEndpoint.formDataParams.length > 0 && (
                                                        <List sx={{ width: "100%", bgcolor: "#49A3FF0F", mt: 2 }}>
                                                            <ListItem
                                                                sx={{
                                                                    borderRadius: 2,
                                                                    my: 1,
                                                                    px: 2,
                                                                    py: 0.5,
                                                                    display: "flex",
                                                                    alignItems: "center",

                                                                }}
                                                            >
                                                                <Grid container alignItems="center" spacing={2}>
                                                                    <Grid item xs={5}>
                                                                        <Typography
                                                                            variant="body1"
                                                                            sx={{
                                                                                fontWeight: "bold",
                                                                                color: "#333",
                                                                            }}
                                                                        >
                                                                            Key
                                                                        </Typography>
                                                                    </Grid>
                                                                    <Grid item xs={5}>
                                                                        <Typography
                                                                            variant="body1"
                                                                            sx={{
                                                                                fontWeight: "bold",
                                                                                color: "#333",
                                                                            }}
                                                                        >
                                                                            Value
                                                                        </Typography>
                                                                    </Grid>

                                                                </Grid>
                                                            </ListItem>
                                                            {activeEndpoint.formDataParams.map((param, formIndex) => (
                                                                <ListItem
                                                                    key={formIndex}
                                                                    sx={{
                                                                        // bgcolor: "#f8f8f8",
                                                                        borderRadius: 2,
                                                                        my: 1,
                                                                        px: 2,
                                                                        py: 0.5,
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                    }}
                                                                >
                                                                    <Grid container alignItems="center" spacing={2}>
                                                                        <Grid item xs={5}>
                                                                            <Typography
                                                                                variant="body1"
                                                                                sx={{
                                                                                    wordBreak: "break-word",
                                                                                    whiteSpace: "normal",
                                                                                    overflowWrap: "anywhere",
                                                                                }}
                                                                            >
                                                                                {formIndex + 1}. {param.key}
                                                                            </Typography>
                                                                        </Grid>
                                                                        <Grid item xs={5}>
                                                                            <Typography
                                                                                variant="body2"
                                                                                sx={{
                                                                                    fontSize: "14px",
                                                                                    color: "#838383",
                                                                                    wordBreak: "break-word",
                                                                                    whiteSpace: "normal",
                                                                                    overflowWrap: "anywhere",
                                                                                }}
                                                                            >
                                                                                {param.value}
                                                                            </Typography>
                                                                        </Grid>
                                                                        <Grid item xs={2} sx={{ textAlign: "right" }}>
                                                                            <IconButton
                                                                                onClick={() =>
                                                                                    handleDeleteFormData(formIndex, endpoints.findIndex(ep => ep.id === activeEndpointId))
                                                                                }

                                                                                color="error"
                                                                            >
                                                                                <DeleteIcon />
                                                                            </IconButton>
                                                                        </Grid>
                                                                    </Grid>
                                                                </ListItem>
                                                            ))}
                                                        </List>
                                                    )}
                                            </Box>
                                        )}
                                        {(activeEndpoint.bodyType || "none") === "json" && (
                                            <TextField
                                                fullWidth
                                                multiline
                                                minRows={4}
                                                label="JSON Body"
                                                placeholder="Enter JSON data..."
                                                value={activeEndpoint.jsonBody || ""}
                                                onChange={(e) => {
                                                    const value = e.target.value;

                                                    setEndpoints((prev) =>
                                                        prev.map((ep) =>
                                                            ep.id === activeEndpoint.id ? { ...ep, jsonBody: value } : ep
                                                        )
                                                    );
                                                }}
                                                sx={{ mt: 1 }}
                                            />
                                        )}

                                        {/* XML Body */}
                                        {(activeEndpoint.bodyType || "none") === "xml" && (
                                            <TextField
                                                fullWidth
                                                multiline
                                                minRows={4}
                                                label="XML Body"
                                                placeholder="Enter XML data..."
                                                value={activeEndpoint.xmlBody || ""}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    setEndpoints((prev) =>
                                                        prev.map((ep) =>
                                                            ep.id === activeEndpoint.id ? { ...ep, xmlBody: value } : ep
                                                        )
                                                    );
                                                }}
                                                sx={{ mt: 1 }}
                                            />
                                        )}

                                        {/* Response Type */}
                                        <FormControl fullWidth sx={{ mt: 2 }}>
                                            <InputLabel id={`response-type-label-${activeEndpoint.id}`}>
                                                Response Type
                                            </InputLabel>
                                            <Select
                                                labelId={`response-type-label-${activeEndpoint.id}`}
                                                value={activeEndpoint.responseType}
                                                label="Response Type"
                                                onChange={(e) => {
                                                    const value = e.target.value
                                                    setEndpoints((prev) =>
                                                        prev.map((ep) =>
                                                            ep.id === activeEndpoint.id ? { ...ep, responseType: value } : ep
                                                        )
                                                    )
                                                }}
                                                MenuProps={{
                                                    PaperProps: {
                                                        style: {
                                                            maxHeight: 250,
                                                            width: 250,
                                                        },
                                                    },
                                                    anchorOrigin: {
                                                        vertical: "bottom",
                                                        horizontal: "left",
                                                    },
                                                    transformOrigin: {
                                                        vertical: "top",
                                                        horizontal: "left",
                                                    },
                                                    disablePortal: true, // ✅ keep menu near the component
                                                }}
                                            >
                                                <MenuItem value="application/json">application/json</MenuItem>
                                                <MenuItem value="application/xml">
                                                    application/xml or text/xml
                                                </MenuItem>
                                                <MenuItem value="text/plain">text/plain</MenuItem>
                                                <MenuItem value="text/html">text/html</MenuItem>
                                                <MenuItem value="text/csv">text/csv</MenuItem>
                                                <MenuItem value="application/x-yaml">
                                                    application/x-yaml or text/yaml
                                                </MenuItem>
                                                <MenuItem value="application/pdf">application/pdf</MenuItem>
                                                <MenuItem value="image/jpeg">image/jpeg</MenuItem>
                                                <MenuItem value="image/png">image/png</MenuItem>
                                                <MenuItem value=" application/vnd.ms-excel">
                                                    {" "}
                                                    application/vnd.ms-excel
                                                </MenuItem>
                                                <MenuItem value="spreadsheet">
                                                    application/vnd.openxmlformats-officedocument.spreadsheetml.sheet
                                                </MenuItem>
                                                <MenuItem value="application/msword">
                                                    application/msword
                                                </MenuItem>
                                                <MenuItem value="document">
                                                    application/vnd.openxmlformats-officedocument.wordprocessingml.document
                                                </MenuItem>
                                                <MenuItem value="application/zip">application/zip</MenuItem>
                                                <MenuItem value="application/octet-stream">
                                                    application/octet-stream
                                                </MenuItem>
                                                <MenuItem value="multipart/form-data">
                                                    multipart/form-data
                                                </MenuItem>
                                                <MenuItem value="application/problem+json">
                                                    application/problem+json
                                                </MenuItem>
                                                <MenuItem value="application/problem+xml">
                                                    application/problem+xml
                                                </MenuItem>
                                            </Select>
                                        </FormControl>

                                    </>
                                )}
                                {activeTab === 2 && (
                                    <>
                                        {/* Custom Headers */}
                                        <Typography
                                            variant="subtitle1"
                                            fontWeight={"bold"}
                                            sx={{ mt: 2, mb: 1, fontSize: "14px" }}
                                        >

                                        </Typography>
                                        <Box sx={{ display: "flex", alignItems: "center", gap: 2, width: "100%" }}>
                                            <FormControl sx={{ width: "100%" }}>
                                                <TextField
                                                    //sx={{ width: "230px" }}
                                                    fullWidth
                                                    label="Header Key"
                                                    placeholder="Enter Key"
                                                    value={headerInputs[activeEndpointId]?.headerKey || ""}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        setHeaderInputs((prev) => ({
                                                            ...prev,
                                                            [activeEndpointId]: {
                                                                ...prev[activeEndpointId],
                                                                headerKey: value,
                                                            },
                                                        }));
                                                    }}
                                                />
                                            </FormControl>
                                            <FormControl sx={{ width: "100%" }}>
                                                <TextField
                                                    // sx={{ width: "210px" }}
                                                    fullWidth
                                                    label="Header Value"
                                                    placeholder="Enter Value"
                                                    value={headerInputs[activeEndpointId]?.headerValue || ""}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        setHeaderInputs((prev) => ({
                                                            ...prev,
                                                            [activeEndpointId]: {
                                                                ...prev[activeEndpointId],
                                                                headerValue: value,
                                                            },
                                                        }));
                                                    }}
                                                />
                                            </FormControl>
                                            <Button
                                                onClick={() => handleAddHeader(endpoints.findIndex(ep => ep.id === activeEndpointId))}
                                                variant='contained'
                                                sx={{
                                                    height: "50px",
                                                    textTransform: "none",
                                                    bgcolor: "#0094FB",
                                                    borderRadius: 2,
                                                    fontSize: "16px",
                                                }}

                                                disabled={
                                                    !headerInputs[activeEndpointId]?.headerKey?.trim() ||
                                                    !headerInputs[activeEndpointId]?.headerValue?.trim()
                                                }
                                            >
                                                Add
                                            </Button>
                                        </Box>

                                        {/* Display Custom Headers */}
                                        {activeEndpoint.headers && activeEndpoint.headers.length > 0 && (
                                            <List sx={{ width: "100%", bgcolor: "#49A3FF0F", mt: 2 }}>
                                                <ListItem
                                                    sx={{
                                                        borderRadius: 2,
                                                        my: 1,
                                                        px: 2,
                                                        py: 0.5,
                                                        display: "flex",
                                                        alignItems: "center",

                                                    }}
                                                >
                                                    <Grid container alignItems="center" spacing={2}>
                                                        <Grid item xs={5}>
                                                            <Typography
                                                                variant="body1"
                                                                sx={{
                                                                    fontWeight: "bold",
                                                                    color: "#333",
                                                                }}
                                                            >
                                                                Header  Key
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={5}>
                                                            <Typography
                                                                variant="body1"
                                                                sx={{
                                                                    fontWeight: "bold",
                                                                    color: "#333",
                                                                }}
                                                            >
                                                                Header  Value
                                                            </Typography>
                                                        </Grid>

                                                    </Grid>
                                                </ListItem>
                                                {activeEndpoint.headers.map((header, headerIndex) => (
                                                    <ListItem
                                                        key={headerIndex}
                                                        sx={{

                                                            borderRadius: 2,
                                                            my: 1,
                                                            px: 2,
                                                            py: 0.5,
                                                            display: "flex",
                                                            alignItems: "center",
                                                        }}
                                                    >
                                                        <Grid container alignItems="center" spacing={2}>
                                                            <Grid item xs={5}>
                                                                <Typography
                                                                    variant="body1"
                                                                    sx={{
                                                                        wordBreak: "break-word",
                                                                        whiteSpace: "normal",
                                                                        overflowWrap: "anywhere",
                                                                    }}
                                                                >
                                                                    {headerIndex + 1}. {header.key}
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item xs={5}>
                                                                <Typography
                                                                    variant="body2"
                                                                    sx={{
                                                                        fontSize: "14px",
                                                                        color: "#838383",
                                                                        wordBreak: "break-word",
                                                                        whiteSpace: "normal",
                                                                        overflowWrap: "anywhere",
                                                                    }}
                                                                >
                                                                    {header.value}
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item xs={2} sx={{ textAlign: "right" }}>
                                                                <IconButton
                                                                    onClick={() =>
                                                                        handleDeleteHeader(headerIndex, endpoints.findIndex(ep => ep.id === activeEndpointId))
                                                                    }
                                                                    color="error"
                                                                    disabled={header.isAuthHeader}
                                                                >
                                                                    <DeleteIcon />
                                                                </IconButton>
                                                            </Grid>
                                                        </Grid>
                                                    </ListItem>
                                                ))}
                                            </List>
                                        )}

                                    </>
                                )}
                                {activeTab === 4 && (
                                    <>
                                        {/* Authorization */}
                                        <Typography
                                            sx={{ mt: 1 }}></Typography>

                                        <FormControl fullWidth>
                                            <InputLabel>Authentication Method</InputLabel>
                                            <Select
                                                value={activeEndpoint.authMethod || "none"}
                                                // onChange={(e) => {
                                                //   setAuthMethod(e.target.value);
                                                //   setEndpoints((prev) =>
                                                //     prev.map((ep, i) =>
                                                //       i === index ? { ...ep, authMethod: e.target.value } : ep
                                                //     )
                                                //   );
                                                // }}
                                                onChange={(e) => {
                                                    const selectedAuth = e.target.value;

                                                    if (selectedAuth === "none") {
                                                        updateActiveEndpoint({
                                                            authMethod: selectedAuth,
                                                            bearerToken: "",
                                                            authUserName: "",
                                                            authPassword: "",
                                                            authKeyName: "",
                                                            authKeyValue: "",
                                                            authAddto: "none",
                                                            auth2Flow: "",
                                                            authClientID: "",
                                                            authClientSecret: "",
                                                            authorizationURL: "",
                                                            tokenURL: "",
                                                            scope: "",
                                                            queryParams: activeEndpoint.queryParams?.filter(p => !p.isAuthParam) || [],
                                                            headers: activeEndpoint.headers?.filter(h => !h.isAuthHeader) || [],
                                                        });
                                                    } else {
                                                        updateActiveEndpoint({ authMethod: selectedAuth });
                                                    }
                                                }}


                                                label="Authentication Method"
                                            >
                                                <MenuItem value="none">None</MenuItem>
                                                <MenuItem value="Bearer Token">Bearer Token</MenuItem>
                                                <MenuItem value="Basic Auth">Basic Auth</MenuItem>
                                                <MenuItem value="API Key">API Key</MenuItem>
                                                <MenuItem value="OAuth 2.0">OAuth 2.0</MenuItem>
                                            </Select>
                                        </FormControl>



                                        {/* Bearer Token Auth */}
                                        {activeEndpoint.authMethod === "Bearer Token" && (
                                            <Box mt={2} p={2} borderRadius={2}>
                                                <FormControl fullWidth>
                                                    <TextField
                                                        variant="outlined"
                                                        placeholder="Enter Bearer Token"
                                                        label="Bearer Token"
                                                        value={activeEndpoint.bearerToken || ""}
                                                        onChange={(e) => {
                                                            setBearerToken(e.target.value);
                                                            setEndpoints((prev) =>
                                                                prev.map((ep) =>
                                                                    ep.id === activeEndpoint.id ? { ...ep, bearerToken: e.target.value } : ep
                                                                )
                                                            );
                                                        }}
                                                    />
                                                </FormControl>
                                            </Box>
                                        )}

                                        {/* Basic Auth */}
                                        {activeEndpoint.authMethod === "Basic Auth" && (
                                            <Box mt={2} p={2} bgcolor="#49A3FF0F" borderRadius={2}>
                                                <TextField
                                                    fullWidth
                                                    variant="outlined"
                                                    label="Username"
                                                    placeholder="Enter User Name"
                                                    value={activeEndpoint.authUserName || ""}
                                                    autoComplete="new-username"
                                                    onChange={(e) => {
                                                        setAuthUserName(e.target.value);
                                                        setEndpoints((prev) =>
                                                            prev.map((ep) =>
                                                                ep.id === activeEndpoint.id ? { ...ep, authUserName: e.target.value } : ep
                                                            )
                                                        );
                                                    }}
                                                />
                                                <TextField
                                                    fullWidth
                                                    variant="outlined"
                                                    label="Password"
                                                    type="password"
                                                    sx={{ mt: 2 }}
                                                    placeholder="Enter Password"
                                                    autoComplete="new-password"
                                                    value={activeEndpoint.authPassword || ""}
                                                    onChange={(e) => {
                                                        setAuthPassword(e.target.value);
                                                        setEndpoints((prev) =>
                                                            prev.map((ep) =>
                                                                ep.id === activeEndpoint.id ? { ...ep, authPassword: e.target.value } : ep
                                                            )
                                                        );
                                                    }}
                                                />
                                            </Box>
                                        )}

                                        {/* API Key Auth */}
                                        {activeEndpoint.authMethod === "API Key" && (
                                            <Box mt={2} p={2} bgcolor="#49A3FF0F" borderRadius={2}>
                                                <TextField
                                                    fullWidth
                                                    variant="outlined"
                                                    label="Name"
                                                    placeholder="Enter Key Name"
                                                    autoComplete="new-username"
                                                    value={activeEndpoint.authKeyName || ""}
                                                    // onChange={(e) => {
                                                    //   setAuthKeyName(e.target.value);
                                                    //   setEndpoints((prev) =>
                                                    //     prev.map((ep, i) =>
                                                    //       i === index
                                                    //         ? { ...ep, authKeyName: e.target.value }
                                                    //         : ep
                                                    //     )
                                                    //   );
                                                    // }}

                                                    onChange={(e) => {
                                                        const newKeyValue = e.target.value;
                                                        setAuthKeyName(newKeyValue);
                                                        setEndpoints((prev) =>
                                                            prev.map((ep) =>
                                                                ep.id === activeEndpoint.id
                                                                    ? {
                                                                        ...ep,
                                                                        authKeyName: newKeyValue,
                                                                        // Update query params if authAddto is "query"
                                                                        ...(ep.authAddto === "query" && {
                                                                            queryParams: ep.queryParams?.map(param =>
                                                                                param.isAuthParam ? { ...param, key: newKeyValue } : param
                                                                            ) || []
                                                                        }),

                                                                    }
                                                                    : ep
                                                            )
                                                        );
                                                    }}



                                                />
                                                <TextField
                                                    fullWidth
                                                    variant="outlined"
                                                    type="password"
                                                    label="Value"
                                                    sx={{ mt: 2 }}
                                                    placeholder="Enter Key Value"
                                                    autoComplete="new-password"
                                                    value={activeEndpoint.authKeyValue || ""}
                                                    // onChange={(e) => {
                                                    //   setAuthKeyValue(e.target.value);
                                                    //   setEndpoints((prev) =>
                                                    //     prev.map((ep, i) =>
                                                    //       i === index
                                                    //         ? { ...ep, authKeyValue: e.target.value }
                                                    //         : ep
                                                    //     )
                                                    //   );
                                                    // }}
                                                    onChange={(e) => {
                                                        const newKeyValue = e.target.value;
                                                        setAuthKeyValue(newKeyValue);
                                                        setEndpoints((prev) =>
                                                            prev.map((ep) =>
                                                                ep.id === activeEndpoint.id
                                                                    ? {
                                                                        ...ep,
                                                                        authKeyValue: newKeyValue,
                                                                        // Update query params if authAddto is "query"
                                                                        ...(ep.authAddto === "query" && {
                                                                            queryParams: ep.queryParams?.map(param =>
                                                                                param.isAuthParam ? { ...param, value: newKeyValue } : param
                                                                            ) || []
                                                                        }),
                                                                        ...(ep.authAddto === "header" && {
                                                                            headers: ep.headers?.map(header =>
                                                                                header.isAuthHeader ? { ...header, value: `Bearer ${newKeyValue}` } : header
                                                                            ) || []
                                                                        })
                                                                    }
                                                                    : ep
                                                            )
                                                        );
                                                    }}
                                                />
                                                <FormControl fullWidth>
                                                    <InputLabel sx={{ mt: 2 }}>Add To</InputLabel>
                                                    <Select
                                                        value={activeEndpoint.authAddto || "none"}
                                                        // onChange={(e) => {
                                                        //   setAuthAddto(e.target.value);
                                                        //   setEndpoints((prev) =>
                                                        //     prev.map((ep, i) =>
                                                        //       i === index
                                                        //         ? { ...ep, authAddto: e.target.value }
                                                        //         : ep
                                                        //     )
                                                        //   );
                                                        // }}
                                                        onChange={(e) => {
                                                            const newAddTo = e.target.value;
                                                            setAuthAddto(newAddTo);
                                                            setEndpoints((prev) =>
                                                                prev.map((ep) =>
                                                                    ep.id === activeEndpoint.id
                                                                        ? {
                                                                            ...ep,
                                                                            authAddto: newAddTo,
                                                                            // Handle query params based on selection
                                                                            queryParams: (() => {
                                                                                const currentParams = ep.queryParams || [];

                                                                                if (newAddTo === "query") {
                                                                                    // Add or update auth param in query params
                                                                                    const existingAuthParamIndex = currentParams.findIndex(p => p.isAuthParam);

                                                                                    if (existingAuthParamIndex >= 0) {
                                                                                        // Update existing auth param
                                                                                        return currentParams.map((param, idx) =>
                                                                                            idx === existingAuthParamIndex
                                                                                                ? { key: ep.authKeyName || "", value: ep.authKeyValue || "", isAuthParam: true }
                                                                                                : param
                                                                                        );
                                                                                    } else {
                                                                                        // Add new auth param
                                                                                        return [
                                                                                            ...currentParams,
                                                                                            { key: ep.authKeyName || "", value: ep.authKeyValue || "", isAuthParam: true }
                                                                                        ];
                                                                                    }
                                                                                } else {
                                                                                    // Remove auth param from query params
                                                                                    return currentParams.filter(param => !param.isAuthParam);
                                                                                }
                                                                            })(),

                                                                            headers: (() => {
                                                                                const currentHeaders = ep.headers || [];

                                                                                if (newAddTo === "header") {
                                                                                    // Add or update auth header
                                                                                    const existingAuthHeaderIndex = currentHeaders.findIndex(h => h.isAuthHeader);

                                                                                    if (existingAuthHeaderIndex >= 0) {
                                                                                        // Update existing auth header
                                                                                        return currentHeaders.map((header, idx) =>
                                                                                            idx === existingAuthHeaderIndex
                                                                                                ? { key: "Authorization", value: `Bearer ${ep.authKeyValue || ""}`, isAuthHeader: true }
                                                                                                : header
                                                                                        );
                                                                                    } else {
                                                                                        // Add new auth header
                                                                                        return [
                                                                                            ...currentHeaders,
                                                                                            { key: "Authorization", value: `Bearer ${ep.authKeyValue || ""}`, isAuthHeader: true }
                                                                                        ];
                                                                                    }
                                                                                } else {
                                                                                    // Remove auth header from headers
                                                                                    return currentHeaders.filter(header => !header.isAuthHeader);
                                                                                }
                                                                            })()
                                                                        }
                                                                        : ep
                                                                )
                                                            );
                                                        }}
                                                        label="Add to"
                                                        sx={{ mt: 2 }}
                                                    >
                                                        <MenuItem value="none">None</MenuItem>
                                                        <MenuItem value="query">Query Param</MenuItem>
                                                        <MenuItem value="header">Header</MenuItem>
                                                    </Select>
                                                </FormControl>
                                            </Box>
                                        )}

                                        {/* OAuth 2.0 Auth */}
                                        {activeEndpoint.authMethod === "OAuth 2.0" && (
                                            <Box mt={2} p={2} bgcolor="#49A3FF0F" borderRadius={2}>
                                                <TextField
                                                    fullWidth
                                                    variant="outlined"
                                                    label="Token Name"
                                                    placeholder="Enter Token Name"
                                                    value={activeEndpoint.auth2Flow || ""}
                                                    onChange={(e) => {
                                                        setAuth2Flow(e.target.value);

                                                        setEndpoints((prev) =>
                                                            prev.map((ep) =>
                                                                ep.id === activeEndpoint.id ? { ...ep, auth2Flow: e.target.value } : ep
                                                            )
                                                        );
                                                    }}
                                                />
                                                <TextField
                                                    fullWidth
                                                    variant="outlined"
                                                    label="Client ID"
                                                    placeholder="Enter Client ID"
                                                    value={activeEndpoint.authClientID || ""}
                                                    onChange={(e) => {
                                                        setAuthClientID(e.target.value);
                                                        setEndpoints((prev) =>
                                                            prev.map((ep) =>
                                                                ep.id === activeEndpoint.id ? { ...ep, authClientID: e.target.value } : ep
                                                            )
                                                        );

                                                    }}
                                                    sx={{ mt: 2 }}
                                                />
                                                <TextField
                                                    fullWidth
                                                    variant="outlined"
                                                    label="Client Secret"
                                                    sx={{ mt: 2 }}
                                                    placeholder="Enter Client Secret"
                                                    value={activeEndpoint.authClientSecret || ""}
                                                    onChange={(e) => {
                                                        setAuthClientSecret(e.target.value);
                                                        setEndpoints((prev) =>
                                                            prev.map((ep) =>
                                                                ep.id === activeEndpoint.id ? { ...ep, authClientSecret: e.target.value } : ep
                                                            )
                                                        );
                                                    }}
                                                />
                                                <TextField
                                                    fullWidth
                                                    variant="outlined"
                                                    label="Authorization URL"
                                                    sx={{ mt: 2 }}
                                                    placeholder="Enter Authorization URL"
                                                    value={activeEndpoint.authorizationURL || ""}
                                                    onChange={(e) => {
                                                        setAuthorizationURL(e.target.value);
                                                        setEndpoints((prev) =>
                                                            prev.map((ep) =>
                                                                ep.id === activeEndpoint.id ? { ...ep, authorizationURL: e.target.value } : ep
                                                            )
                                                        );

                                                    }}
                                                />
                                                <TextField
                                                    fullWidth
                                                    variant="outlined"
                                                    label="Token URL"
                                                    sx={{ mt: 2 }}
                                                    placeholder="Enter Token URL"
                                                    value={activeEndpoint.tokenURL || ""}
                                                    onChange={(e) => {
                                                        setTokenURL(e.target.value);
                                                        setEndpoints((prev) =>
                                                            prev.map((ep) =>
                                                                ep.id === activeEndpoint.id ? { ...ep, tokenURL: e.target.value } : ep
                                                            )
                                                        );
                                                    }}
                                                />
                                                <TextField
                                                    fullWidth
                                                    variant="outlined"
                                                    label="Scope (Space-Separated)"
                                                    sx={{ mt: 2 }}
                                                    placeholder="Enter Scope"
                                                    value={activeEndpoint.scope || ""}
                                                    onChange={(e) => {
                                                        setScope(e.target.value);
                                                        setEndpoints((prev) =>
                                                            prev.map((ep) =>
                                                                ep.id === activeEndpoint.id ? { ...ep, scope: e.target.value } : ep
                                                            )
                                                        );
                                                    }}

                                                />
                                            </Box>
                                        )}
                                    </>
                                )}
                            </Box>
                        )}
                    </Box>

                    {/* Action Buttons */}
                    <Box sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center'
                    }}>
                        {!props.hideButton && (

                            <Box sx={{ display: 'flex', gap: '16px' }}>

                                <Button
                                    variant="outlined"
                                    startIcon={<ResetIcon />}
                                    onClick={resetActiveEndpoint}
                                    sx={{
                                        borderRadius: "8px", color: "#0094FB", borderColor: " #0094FB",
                                        borderWidth: "2px",   // makes border bold
                                        fontWeight: "bold", textTransform: "none",
                                        padding: "4px 16px"
                                    }
                                    }

                                >
                                    Reset Form
                                </Button>

                            </Box>
                        )}
                    </Box>
                </CardContent>
            </StyledCard>

            {/* Bottom Navigation */}
            <Box sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
                mt: 1
            }}>

                <Box sx={{ display: 'flex', gap: 2 }}>
                    {!props.hideButton && (

                        <Button variant="outlined"
                            onClick={generateAPIDocumentation}
                            disabled={
                                !apiUrl
                            }
                            sx={{
                                borderRadius: "8px", color: "#0094FB", borderColor: " #0094FB",
                                borderWidth: "2px",   // makes border bold
                                fontWeight: "bold", textTransform: "none",
                                padding: "4px 16px"
                            }
                            }
                        >
                            <GenerateButtonIcon style={{ marginRight: 6 }} />

                            Import
                        </Button>

                    )}
                </Box>
            </Box>
            <APIDocPopup open={successPopup} handleClose={handleCloseSuccessPopup} />
            <MessagePopup
                modalOpen={popupOpen}
                message={popupMessage}
                okayHandler={() => setPopupOpen(false)}
            />

        </Box>
    );
};

export default ManualConfigForMultiSource;